import { registerBrick, Auth } from 'olympe';
import {ReactBrick, useMUITheme, updateNavigationState} from "@olympeio/core";
import React from "react";
import { Button, Card, CardContent, Accordion, AccordionSummary, AccordionDetails, Typography } from "@mui/material";
import { ChevronDown, LineChart } from "lucide-react";
import { ThemeProvider } from '@mui/material/styles';


export default class HomePageContent extends ReactBrick {

    /**
     * @override
     */
    static getReactComponent($) {
        return (props) => {
            const theme = useMUITheme($);
            return (
                <ThemeProvider theme={theme}>
                    <div className="h-full w-full bg-indigo-50 flex flex-col items-center p-6 overflow-y-auto">
                        {/* Header */}
                        <header className="w-full max-w-4xl text-center">
                            <div className="flex flex-col md:flex-row items-center">
                                <div className="text-justify md:text-left md:w-2/3">
                                    <h1 className="text-4xl font-bold text-indigo-700">Raclobot: Le Bot de Trading</h1>
                                    <h2 className="text-indigo-700">Il va religieusement racler la crypto pour ajouter du gras a votre épargne !</h2>
                                    <p className="mt-4 text-gray-600">
                                        Raclobot est un robot de trading suisse conçu pour optimiser votre épargne. Il utilise des stratégies performantes pour maximiser vos rendements tout en réduisant les risques du marché des cryptomonnaies.
                                    </p>
                                    <p className="mt-4 text-gray-600">
                                        Rejoignez une communauté d'investisseurs avertis et laissez Raclobot travailler pour vous ! Profitez de ses performances éprouvées pour dynamiser votre portefeuille en toute sérénité, sans stress ni gestion quotidienne.
                                    </p>
                                    <p className="mt-4 text-gray-600">
                                        Utilisez notre simulateur gratuitement afin de constater par vous même les performances du bot sur les données de ces dernières années !
                                    </p>
                                </div>

                                <div className="mt-6 md:mt-0 md:ml-8 md:w-1/3">
                                    <img src="/images/raclobot.png" alt="Raclobot" className="w-full h-auto"/>
                                </div>
                            </div>
                        </header>

                        {/* Strategies Section */}
                        <h3 className="text-xl font-semibold text-indigo-700 m-4">Nos stratégies</h3>
                        <section className="w-full max-w-4xl grid md:grid-cols-2 gap-4 my-4">
                            <Card className="relative cursor-pointer " onClick={() => updateNavigationState('/analysis/range')}>
                                <CardContent className="p-6">
                                    <h2 className="text-2xl font-semibold text-indigo-700">Stratégie Prudente</h2>
                                    <p className="text-gray-600 mt-2">
                                        Une approche sécurisée offrant un rendement stable et constant. Idéale pour les investisseurs long-terme et prudents.
                                    </p>
                                    <p className="text-green-600 mt-2 font-bold">Rendement sur la moyenne des 5 dernières années : 7-10% par an</p>
                                    <br /><br />
                                    <div className="absolute bottom-4 right-4 flex items-center text-indigo-700 cursor-pointer">
                                        <LineChart className="w-6 h-6 mr-2" />
                                        <span className="font-semibold">Lancer le simulateur</span>
                                    </div>
                                </CardContent>
                            </Card>

                            <Card className="relative cursor-pointer" onClick={() => updateNavigationState('/analysis/trend')}>
                                <CardContent className="p-6">
                                    <h2 className="text-2xl font-semibold text-indigo-700">Stratégie Dynamique</h2>
                                    <p className="text-gray-600 mt-2">
                                        Une méthode plus agressive avec des gains plus élevés, pour ceux prêts à prendre plus de risques.
                                    </p>
                                    <p className="text-green-600 mt-2 font-bold">Rendement sur la moyenne des 5 dernières années</p>
                                    <div className="w-full max-w-md mx-auto">
                                        <ul className="grid grid-cols-2 text-green-600 font-semibold">
                                            <li>BTC : 40-45%/an</li>
                                            <li>ETH : 80-85%/an</li>
                                            <li>SOL : >130%/an</li>
                                            <li>DOGE : >200%/an</li>
                                            <li>XRP : 70-75%/an</li>
                                            <li>ADA : >110%/an</li>
                                            <li>XLM : 15-20%/an</li>
                                            <li>HBAR : 30-35%/an</li>
                                            <li>AVAX : 20-25%/an</li>
                                            <li>SUI : 50-60%/an</li>
                                        </ul>
                                    </div>
                                    <br /><br />
                                    <div className="absolute bottom-4 right-4 flex items-center text-indigo-700 cursor-pointer">
                                        <LineChart className="w-6 h-6 mr-2" />
                                        <span className="font-semibold">Lancer le simulateur</span>
                                    </div>
                                </CardContent>
                            </Card>
                        </section>

                        {/* Fees Section */}
                        <section className="w-full max-w-4xl text-center mt-8">
                            <h3 className="text-xl font-semibold text-indigo-700 m-4">Frais de la plateforme</h3>
                            <p className="text-gray-600 mt-2 text-left">Notre modèle de tarification est simple et transparent :</p>
                            <ul className="list-disc text-gray-600 mt-2 text-left px-6">
                                <li>Nous facturons <span className="text-green-600" ><span style={{textDecoration: 'line-through'}}>15% des gains</span><strong> 10% (pour les premiers clients)</strong></span> réalisés sur les trades gagnants.</li>
                                <li>Aucun frais sur les pertes.</li>
                            </ul>
                            <p className="text-green-600 mt-2 font-bold text-left">Notre intérêt est donc le même que le vôtre: réaliser des trades gagnants !</p>
                        </section>

                        {/* FAQ Section */}
                        <section className="w-full max-w-4xl mt-8">
                            <h3 className="text-xl font-semibold text-indigo-700 text-center m-4">FAQ - Sécurité et Fonctionnement</h3>
                            <Accordion>
                                <AccordionSummary expandIcon={<ChevronDown />}>
                                    <Typography className="font-semibold">Comment le robot fonctionne-t-il ?</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography className="text-gray-500">
                                        Notre robot utilise une clé d'api que vous générez auprès de Binance. Vous êtes en charge de placer les fonds sur binance,
                                        le bot se chargera uniquement de générer les ordres d'achat et de ventes aux moments déterminés par la stratégie choisie.
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<ChevronDown />}>
                                    <Typography className="font-semibold">Mon compte Binance est-il en sécurité ?</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography className="text-gray-500">
                                        Absolument. Le bot utilise votre clé API uniquement pour passer des ordres de trading : <strong>il n’a aucun accès à vos fonds ni à vos retraits</strong>. <br /><br />
                                        De plus, cette clé API est sécurisée à plusieurs niveaux :
                                    </Typography>
                                    <ul className="text-gray-500 m-4" style={{listStyleType: 'disc'}}>
                                        <li>Elle est restreinte exclusivement à notre serveur. Même en cas de fuite, elle serait inutilisable par un tiers.</li>
                                        <li>Elle est stockée de manière chiffrée dans notre base de données, avec un cryptage de niveau <strong>AES-256</strong>, l’un des standards les plus sûrs actuellement.</li>
                                    </ul>
                                    <Typography className="text-gray-500">
                                        Votre sécurité est notre priorité.
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<ChevronDown />}>
                                    <Typography className="font-semibold">Quels sont les accès donnés au bot ?</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography className="text-gray-500">
                                        Vous ne devez donner que l'autorisation de passer des ordres sur votre compte Binance. Les accès aux retraits et aux modifications de compte ne sont pas requis et doivent rester désactivés.
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<ChevronDown />}>
                                    <Typography className="font-semibold">Puis-je arrêter le bot à tout moment ?</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography className="text-gray-500">
                                        Oui, vous pouvez arrêter le bot via notre plateforme à tout moment ou désactiver votre clé API sur Binance.
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<ChevronDown />}>
                                    <Typography className="font-semibold">Comment sont prélevés les frais de la plateforme ?</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography className="text-gray-500">
                                        Chaque mois, nous considérons les trades gagnants sur la période et emettons une facture qu'il vous revient de règler dans les 30j.
                                        Les fonds ne sont pas automatiquement déduit de Binance pour des raisons de sécurité.
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<ChevronDown />}>
                                    <Typography className="font-semibold">Puis-je partager mon capital avec de multiples stratégies ?</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography className="text-gray-500">
                                        Oui, une fois client vous avez accès a l'interface d'administration qui vous permet de démarrer ou arrêter autant de stratégies que vous le souhaitez sur les paires disponibles.
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary expandIcon={<ChevronDown />}>
                                    <Typography className="font-semibold">Quel recours ai-je en cas de soucis / Qui est l'auteur ?</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography className="text-gray-500">
                                        Raclobot est une marque de la société Orionis Applications SARL, inscrite au registre du commerce Suisse.
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                        </section>

                        {/* Call to Action */}
                        <section className="w-full max-w-4xl text-center mt-8">
                            <h3 className="text-xl font-semibold text-indigo-700 m-4">Découvrez notre interface sans engagement !</h3>
                            <p className="text-gray-600 mt-2">
                                Vous vous demandez à quoi ressemble notre portail ?<br/>
                                Explorez l'application avec un accès démo instantané – aucune inscription requise.
                            </p>
                            <div className="m-4">
                                <Button variant="contained" color="primary" className="mt-4" onClick={() => Auth.loginSRP('manager', 'manage')}>
                                    Entrez dans la démo
                                </Button>
                            </div>
                        </section>

                        {/* Call to Action */}
                        <section className="w-full max-w-4xl text-center mt-8">
                            <h3 className="text-xl font-semibold text-indigo-700 m-4">Commencez dès aujourd'hui !</h3>
                            <p className="text-gray-600 mt-2">
                                Notre bot gère déjà plus de <span className="text-xl font-semibold text-indigo-700">{$.get('amount')} USDT</span> pour nos clients en toute sécurité. <br/>
                                Rejoignez-les et laissez notre bot optimiser votre epargne.
                            </p>
                            <div className="m-4">
                                <Button variant="contained" color="primary" className="mt-4" onClick={() => updateNavigationState('/register')}>
                                    Enregistrez-vous ici !
                                </Button>
                            </div>
                        </section>

                        {/* Disclaimer */}
                        <footer className="w-full max-w-4xl mt-12 p-4 border-t border-gray-300 text-center text-sm text-gray-500">
                            <p>
                                Avertissement : Le trading comporte des risques de pertes. Aucune performance passée ne garantit des résultats futurs.
                                Investissez uniquement ce que vous pouvez vous permettre de perdre.
                            </p>
                        </footer>
                    </div>
                </ThemeProvider>
            );
        }
    }
}

registerBrick('0195938ae15a28927f80', HomePageContent);
